<div class="accordion" id="accordionExample" style="margin-top: -25px;">
    <div class="accordion-item">
        <h2 class="accordion-header" id="heading1">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse1" aria-expanded="false" aria-controls="collapse1">
                Opbrengsten
            </button>
        </h2>
        <div id="collapse1" class="accordion-collapse collapse" aria-labelledby="heading1"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                Onder 'Opbrengsten' vallen onder meer:
                <li class="list">netto-omzet (omzet exclusief btw en na aftrek van eventuele kortingen)</li>
                <li class="list">wijzigingen in voorraden gereed product en onderhanden werk (werkzaamheden die de
                    ondernemer heeft verricht, maar nog niet gefactureerd)
                </li>
                <li class="list">geactiveerde productie voor het eigen bedrijf (de productie van bedrijfsmiddelen in en
                    voor het
                    eigen bedrijf)
                </li>
                <li class="list">overige opbrengsten</li>
            </div>
        </div>
    </div>

    <div class="accordion-item">
        <h2 class="accordion-header" id="heading2">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse2" aria-expanded="false" aria-controls="collapse2">
                Financiële baten
            </button>
        </h2>
        <div id="collapse2" class="accordion-collapse collapse" aria-labelledby="heading2"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                Onder 'Financiële baten' vallen onder meer:
                <li class="list">opbrengsten van overige vorderingen</li>
                <li class="list">rente op banktegoeden</li>
                <li class="list">ontvangen dividend</li>
                <li class="list">kwijtscheldingswinst</li>
                <li class="list">waardevermeerdering van vorderingen</li>
                <li class="list">waardevermeerdering van effecten</li>

                <div class="space20"></div>

                <b>Ontvangen dividend</b><br/>
                Vul het ontvangen dividend van aandelen die tot het ondernemingsvermogen behoren. Het gaat om het
                bruto-dividend in, dus inclusief de eventuele dividendbelasting.

                <div class="space20"></div>

                <b>Kwijtscheldingswinst</b><br/>
                De vrijstelling voor kwijtscheldingswinst is een vrijstelling voor winst die ontstaat als een
                schuldeiser afziet van het innen van een schuld die de ondernemer bij hem hebt. In dat geval levert dit
                de ondernemer winst op. Deze winst is vrijgesteld onder de volgende voorwaarden:

                <li class="list">De schuld is niet te innen, bijvoorbeeld door een (dreigend) faillissement.</li>
                <li class="list">Van de winst die is behaald met de kwijtschelding, is alleen het deel vrijgesteld dat
                    hoger is dan
                    de te verrekenen verliezen uit werk en woning van de jaren tot en met {{ this.year - 1 }} en het
                    verlies uit werk en woning over {{ this.year }}. Verliezen in jaren die volgen op het jaar van de
                    kwijtschelding, verkleinen het vrijgestelde bedrag niet.
                </li>
            </div>
        </div>
    </div>

    <div class="accordion-item">
        <h2 class="accordion-header" id="heading3">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse3" aria-expanded="false" aria-controls="collapse3">
                Buitengewone baten
            </button>
        </h2>
        <div id="collapse3" class="accordion-collapse collapse" aria-labelledby="heading3"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                Onder 'Buitengewone baten' vallen baten die niet voortkomen uit de gewone bedrijfsvoering, zoals:

                <li class="list">onttrekking privégebruik auto, woning of fiets van de onderneming</li>
                <li class="list">opheffing van de positieve terugkeerreserve</li>
                <li class="list">boekwinst op activa</li>
                <li class="list">btw-voordeel door de kleineondernemersregeling</li>

            </div>
        </div>
    </div>

    <div class="accordion-item">
        <h2 class="accordion-header" id="heading33">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse33" aria-expanded="false" aria-controls="collapse33">
                Stakingswinst (doorschuiven of staken van de onderneming)
            </button>
        </h2>
        <div id="collapse33" class="accordion-collapse collapse" aria-labelledby="heading33"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                Heb je de onderneming geheel of gedeeltelijk gestaakt of doorgeschoven? Dan moet je in principe
                belasting
                betalen over de stakingswinst. In bepaalde gevallen kan de belastingclaim over de stakingswinst worden
                doorgeschoven naar degene die de onderneming heeft overgenomen. Ook heb je misschien recht op
                stakingsaftrek over het deel van de oudedagsreserve dat vrijvalt door het doorschuiven van de
                onderneming.
                <div class="space20"></div>
                <b>Stakingswinst</b><br/>
                Stakingswinst is de winst die je hebt behaald als direct gevolg van de staking van (een deel van) de
                onderneming. Bijvoorbeeld in de volgende situaties:
                <ul>
                    <li>Je verkoopt (een deel van) de onderneming. Het verschil tussen de verkoopprijs en de boekwaarde
                        is de stakingswinst.
                    </li>
                    <li>Je brengt (een deel van) uw onderneming over naar het privévermogen. Het verschil tussen de
                        waarde in heteconomisch verkeer en de boekwaarde is de stakingswinst.
                    </li>
                </ul>
                <div class="space20"></div>
                in veel gevallen zal de stakingswinst bestaan uit een of meer van de volgende onderdelen:<br/>
                <ul>
                    <li>resultaat op onroerende zaken</li>
                    <li>winst op immateriële activa</li>
                    <li>winst op overige activa</li>
                    <li>vrijval oudedagsreserve</li>
                    <li>vrijval overige fiscale reserves</li>
                    <li>overig resultaat</li>
                    <li>desinvesteringsbijtelling wegens het staken van de onderneming</li>
                </ul>
                <div class="space20"></div>
                <b>Fiscale reserves</b><br/>
                Heb je in de onderneming fiscale reserves opgebouwd? En staak je de onderneming? Dan moet je de waarde
                van de fiscale reserves bij de stakingswinst tellen. Staak je een deel van de onderneming? Dan is het
                mogelijk dat je ook een deel van de waarde van de fiscale reserves bij de stakingswinst moet
                tellen.<br/>
                Tot de fiscale reserves behoren de egalisatiereserve, de herinvesteringsreserve en de oudedagsreserve.

                <div class="space20"></div>
                <b>Wanneer kan een ondernemer zijn onderneming doorschuiven?</b><br/>
                In de volgende situaties kan een ondernemer (een gedeelte van) zijn onderneming (onder voorwaarden)
                doorschuiven en een eindafrekening voorkomen:<br/>
                <ul>
                    <li>De ondernemer overlijdt.</li>
                    <li>Het huwelijk van de ondernemer wordt ontbonden.</li>
                    <li>De ondernemer draagt zijn onderneming over aan een andere ondernemer uit het
                        samenwerkingsverband
                        met
                        wie hij al minimaal 36 maanden heeft samengewerkt.
                    </li>
                    <li> De onderneming krijgt een doorstart.</li>
                    <li>De ondernemer brengt zijn hele onderneming onder in een eigen bv.</li>
                    <li>De ondernemer draagt zijn onderneming over aan een werknemer die al minimaal 36 maanden bij hem
                        in loondienst is geweest.
                    </li>
                </ul>

                <div class="space20"></div>
                <b>Stakingsbalans</b><br/>
                Heb je de onderneming gestaakt? Dan kun je aan het einde van het boekjaar de activa en passiva opnemen
                in de balans. Dit doet je door de activa en passiva inclusief de stille reserves (de economische waarde)
                te vermelden. Het einde van het boekjaar is de datum waarop je de onderneming hebt gestaakt. Deze datum
                kan samenvallen met het einde van het kalenderjaar.

                <div class="space20"></div>
                <b>Desinvesteringsbijtelling</b><br/>
                Als je (een deel van) de onderneming staakt, ben je desinvesteringsbijtelling verschuldigd over de
                bedrijfsmiddelen waarvoor je in het verleden investeringsaftrek hebt gekregen en waarvan de termijn
                waarbinnen desinvesteringsbijtelling is verschuldigd, nog niet is verstreken.

                <div class="space20"></div>
                <b>Invullen stakingswinst en recht op stakingsaftrek</b><br/>
                Bij het onderdeel 'Resultatenrekening' komt de mogelijkheid de stakingswinst naar voren als er een
                stakingsdatum is ingevuld bij het onderdeel 'Vragen vooraf'. Op basis van deze stakingsdatum wordt ook
                de vraag 'Is er recht op stakingsaftrek?' geactiveerd bij het onderdeel 'Ondernemersaftrek'.


            </div>
        </div>
    </div>

    <div class="accordion-item">
        <h2 class="accordion-header" id="heading10">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse10" aria-expanded="false" aria-controls="collapse10">
                Aftrekbare , niet aftrekbare, beperkt aftrekbare kosten en kosten met een drempel
            </button>
        </h2>
        <div id="collapse10" class="accordion-collapse collapse" aria-labelledby="heading10"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                <b>Welke kosten mag je aftrekken?</b><br/>
                Van de winst mag je zakelijke kosten aftrekken. Hiervoor geldt het volgende:

                <li class="list">Zakelijke kosten mag je helemaal aftrekken. <br/>
                    Dit zijn kosten die binnen redelijke grenzen nodig zijn voor de uitoefening van je werk, zoals
                    vakliteratuur.
                </li>
                <li class="list">Kosten die geen zakelijk karakter hebben, mag je niet aftrekken.</li>
                <li class="list">Van kosten die een zakelijk én privékarakter hebben, mag je alleen het zakelijk deel
                    aftrekken.
                </li>
                <li class="list">Voor sommige kosten geldt een drempel, een normering of een aftrekbaar bedrag. Welke
                    kosten dat zijn, lees je bij 'Kosten met een drempel'. Eventuele vergoedingen die je voor zakelijke
                    kosten ontvangt, moet je bij je opbrengsten tellen.
                </li>

                <div class="space20"></div>

                <b>Welke kosten mag je niet aftrekken?</b><br/>
                Van de winst mag je bijvoorbeeld de volgende kosten niet aftrekken:

                <li class="list">kosten van een werkruimte en de inrichting ervan in de woning die je niet als zakelijk
                    aanmerkt<br/>
                    In een aantal situaties zijn deze kosten wel aftrekbaar.
                </li>
                <li class="list">telefoonabonnementen voor telefoonaansluitingen in de woonruimte</li>
                <li class="list">kleding, met uitzondering van werkkledingKleding die je (bijna) uitsluitend kunt dragen
                    in het kader van de onderneming. <br/>
                    Dit moet blijken uit de uiterlijke kenmerken van de kleding (bijvoorbeeld: een uniform of overall).
                    Is de kleding ook geschikt om buiten de onderneming te dragen? Dan moet de kleding zijn voorzien van
                    een beeldmerk met een oppervlakte van minimaal 70 cm2. Het beeldmerk moet verwijzen naar de
                    onderneming.
                </li>

                <li class="list">kosten van persoonlijke verzorging</li>

                <li class="list">ingehouden loonbelasting en premie volksverzekeringen en inkomensafhankelijke bijdragen
                    Zorgverzekeringswet
                </li>

                <li class="list">een vergoeding voor het werk van de partner als die lager is dan € 5.000<br/>
                    Is de vergoeding € 5.000 of hoger? Dan is het hele bedrag aftrekbaar.
                </li>

                <li class="list">kosten van muziekinstrumenten, geluidsapparatuur, gereedschappen, computers,
                    beeldapparatuur en dergelijke<br/>
                    Dit geldt als deze horen bij het privévermogen of als de ondernemer deze privé heeft gehuurd.
                </li>

                <li class="list">standsuitgaven, zoals het lidmaatschap van een serviceclub of de Rotary</li>

                <li class="list">kosten van vaartuigen voor representatieve doeleinden</li>

                <li class="list">geldboetes die een strafrechter heeft opgelegd, geldsommen om strafvervolging te
                    voorkomen en bestuurlijke boetes<br/>
                    Dit geldt ook voor buitenlandse boetes.
                </li>

                <li class="list">boetes en verhogingen die zijn opgelegd bij de heffing van belastingen en premies</li>

                <li class="list">boetes opgelegd door de Autoriteit Consument en Markt (ACM)</li>

                <div class="space20"></div>

                <b>Deel aftrekbare kosten</b><br/>
                Voor sommige kosten geldt dat ze voor een deel aftrekbaar zijn.
                Dit geldt voor de volgende kosten:
                <li class="list">reiskosten<br/>
                    Je mag een vast bedrag van € 0,{{ this.kmPrijs }} per zakelijk gereden kilometer aftrekken. Het
                    maakt
                    daarbij niet
                    uit welk privévervoermiddel er gebruikt wordt.
                </li>
                <li class="list">huisvesting buiten de woonplaats<br/>
                    Je mag de kosten van huisvesting buiten de woonplaats maximaal 2 jaar aftrekken.
                </li>
                <li class="list">verhuiskosten<br/>
                    Je mag alleen de kosten aftrekken die de ondernemer maakt om de inboedel over te brengen naar een
                    andere woonruimte.
                    Daarnaast mag je een vast bedrag van € {{ this.verhuiskostenAftrek | number:'1.0-0' }} aftrekken.
                </li>
                <li class="list">gebruiksvergoeding voor privébezittingen (geen vervoermiddelen) die de ondernemer
                    zakelijk gebruikt
                    <br/>
                    Deze vergoeding is beperkt. Je mag maximaal het bedrag van het voordeel uit sparen en beleggen
                    aftrekken dat voor deze bezittingen geldt. Je hoeft daarbij geen rekening te houden met het
                    heffingsvrij vermogen.<br/>
                </li>
                <li class="list">gebruiksvergoeding voor privé gehuurde zaken (geen vervoermiddelen) die de ondernemer
                    zakelijk
                    gebruikt<br/>
                    Je mag de kosten aftrekken van het deel dat de ondernemer zakelijk gebruikt. Het gaat hier om het
                    deel van de huurprijs en eventuele andere huurderslasten.
                </li>
                <li class="list">Pensioenpremies die de ondernemer betaalt aan een beroeps- of
                    bedrijfstakpensioenregeling waar hij
                    verplicht aan deelneemt op grond van 1 van de volgende wetten:
                </li>
                <ul>
                    <li class="list">de Wet verplichte deelneming in een bedrijfstakpensioenfonds 2000</li>
                    <li class="list">de Wet op het notarisambt</li>
                    <li class="list">de Wet verplichte beroepspensioenregeling</li>
                    Je mag de verplichte premies aftrekken als de ondernemer voldoet aan de volgende voorwaarde: de
                    pensioenopbouw is maximaal 1,875% van het pensioengevend inkomen volgens het middelloonstelsel met
                    een maximum van € 2.154. De premies voor de vrijwillige aanvulling mag je aftrekken voor maximaal
                    1/3 van de verplichte premies.
                </ul>

                <div class="space10"></div>

                <b>Kosten met een drempel</b><br/>
                Voor sommige kosten geldt een drempel. Je mag alleen het bedrag boven de drempel aftrekken.
                Deze drempel geldt voor de volgende kosten:
                <li class="list">kosten voor voeding, drank en genotmiddelen</li>
                <li class="list">kosten voor representatie zoals recepties, feestelijke bijeenkomsten en vermaak</li>
                <li class="list">kosten voor onder meer congressen, seminars, symposia, excursies en studiereizen</li>
                <div class="space20"></div>
                De drempel van € {{ this.drempelZakelijkeKosten | number:'1.0-0' }} geldt ook voor de reis- en
                verblijfskosten in verband met congressen en
                dergelijke. Van die reis- en verblijfskosten is bovendien maximaal
                € {{ this.maxReisVerblijfkosten | number:'1.0-0' }} aftrekbaar. Is het voor de
                onderneming noodzakelijk om een congres en dergelijke bij te wonen? Dan geldt dit maximum niet.
                <div class="space20"></div>
                De ondernemer mag er ook voor kiezen om het totaal van deze kosten voor {{ this.percentageKosten }}% af
                te trekken. Je hoeft deze kosten dan
                niet te verminderen met € {{ this.drempelZakelijkeKosten | number:'1.0-0' }}.


            </div>
        </div>
    </div>

    <div class="accordion-item">
        <h2 class="accordion-header" id="heading4">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse4" aria-expanded="false" aria-controls="collapse4">
                Inkoopkosten
            </button>
        </h2>
        <div id="collapse4" class="accordion-collapse collapse" aria-labelledby="heading4"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                Onder deze kosten vallen:

                <li class="list">de kosten van grond- en hulpstoffen</li>
                <li class="list">de inkoopprijs van de verkopen</li>
                <li class="list">de kosten van uitbesteed werk en andere externe kosten</li>

                <div class="space20"></div>

                Andere externe kosten zijn bijvoorbeeld winstaandelen die kunnen worden beschouwd als tegenprestaties
                voor een licentie of een octrooi.

            </div>
        </div>
    </div>

    <div class="accordion-item">
        <h2 class="accordion-header" id="heading5">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse5" aria-expanded="false" aria-controls="collapse5">
                Verkoopkosten
            </button>
        </h2>
        <div id="collapse5" class="accordion-collapse collapse" aria-labelledby="heading5"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                Hieronder vallen de kosten in die de ondernemer maakt voor het behalen van de omzet, zoals
                reclamekosten.
            </div>
        </div>
    </div>

    <div class="accordion-item">
        <h2 class="accordion-header" id="heading6">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse6" aria-expanded="false" aria-controls="collapse6">
                Personeelskosten
            </button>
        </h2>
        <div id="collapse6" class="accordion-collapse collapse" aria-labelledby="heading6"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                Onder 'Personeelskosten' vallen onder meer:
                <li class="list">lonen en salarissen</li>
                <li class="list">arbeidsbeloning aan je fiscale partner</li>
                <li class="list">sociale lasten</li>
                <li class="list">pensioenlasten</li>
            </div>
        </div>
    </div>

    <div class="accordion-item">
        <h2 class="accordion-header" id="heading7">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse7" aria-expanded="false" aria-controls="collapse7">
                Huisvestingskosten
            </button>
        </h2>
        <div id="collapse7" class="accordion-collapse collapse" aria-labelledby="heading7"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                Het gaat bijvoorbeeld om de kosten voor huur, gas, water, licht en opstalverzekering van de huisvesting.

                <div class="space20"></div>

                Is er sprake van een werkruimte in de privéwoning? Dan zijn de kosten daarvan meestal niet aftrekbaar.
                In sommige
                situaties mag de ondernemer deze kosten wel aftrekken. Een handig hulpmiddel daarbij is de
                rekenhulp <a target="_blank"
                             href="https://www.belastingdienst.nl/wps/wcm/connect/nl/ondernemers/content/zijn-kosten-voor-de-werkruimte-in-mijn-woning-aftrekbaar">
                'Werkruimte in de woning'</a> op belastingdienst.nl.
            </div>
        </div>
    </div>

    <div class="accordion-item">
        <h2 class="accordion-header" id="heading8">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse8" aria-expanded="false" aria-controls="collapse8">
                Autokosten
            </button>
        </h2>
        <div id="collapse8" class="accordion-collapse collapse" aria-labelledby="heading8"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                Het gaat hierbij om de auto- en transportkosten van de onderneming.

                <div class="space20"></div>

                <b>Zakelijk gebruik privévervoermiddel</b><br/>
                Gebruikt de ondernemer in deu onderneming een vervoermiddel dat zijn eigendom was of dat hij privé
                huurde? Dan mag je voor de zakelijke ritten € 0,{{ this.kmPrijs }} per kilometer bij de kosten tellen.

                <div class="space20"></div>

                <b>Privégebruik zakelijke auto</b><br/>
                Reed de ondernemer dit boekjaar in een auto van de onderneming? En gebruikte hij deze auto ook privé?
                Dan kun je de
                bijtelling voor het privégebruik invullen bij 'Buitengewone baten' of in mindering brengen op de
                autokosten.
            </div>
        </div>
    </div>

    <div class="accordion-item">
        <h2 class="accordion-header" id="heading9">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse9" aria-expanded="false" aria-controls="collapse9">
                Afschrijvingen
            </button>
        </h2>
        <div id="collapse9" class="accordion-collapse collapse" aria-labelledby="heading9"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                Het gaat hier om afschrijvingen op bedrijfsmiddelen inclusief de willekeurige afschrijvingen. De
                jaarlijkse afschrijving is
                het deel van de aanschaf- of voortbrengingskosten dat nog niet is afgeschreven en dat aan het boekjaar
                kan worden toegerekend.

                <div class="space20"></div>

                Het gaat om afschrijvingen op:
                <li class="list">goodwill</li>
                <li class="list">overige immateriële vaste activa</li>
                <li class="list">gebouwen en terreinen</li>
                <li class="list">machines en installaties</li>
                <li class="list">productierechten</li>
                <li class="list">overige materiële vaste activa</li>

                <div class="space20"></div>

                <b>Jaarlijkse afschrijving op bedrijfsmiddelen</b><br/>
                De jaarlijkse afschrijving op bedrijfsmiddelen is maximaal 20% van de (oorspronkelijke) aanschaf- of
                voortbrengingskosten.<br/>
                De afschrijving op goodwill is maximaal 10% van de (oorspronkelijke) aanschafkosten. De afschrijving op
                gebouwen is beperkt.<br/>
                De kosten van bedrijfsmiddelen met een geringe aanschafwaarde (minder dan € 450) mogen in 1 keer ten
                laste van de winst gebracht worden.
            </div>
        </div>
    </div>

    <div class="accordion-item">
        <h2 class="accordion-header" id="heading11">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse11" aria-expanded="false" aria-controls="collapse11">
                Financiële lasten
            </button>
        </h2>
        <div id="collapse11" class="accordion-collapse collapse" aria-labelledby="heading11"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                Onder 'Financiële lasten' vallen onder meer:
                <li class="list">kosten van schulden, rentelasten en soortgelijke kosten</li>
                <li class="list">waardevermindering van vorderingen</li>
                <li class="list">waardevermindering van effecten</li>
            </div>
        </div>
    </div>

    <div class="accordion-item">
        <h2 class="accordion-header" id="heading12">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse12" aria-expanded="false" aria-controls="collapse12">
                Buitengewone lasten
            </button>
        </h2>
        <div id="collapse12" class="accordion-collapse collapse" aria-labelledby="heading12"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                Onder 'Buitengewone lasten' vallen lasten die niet voortkomen uit de gewone bedrijfsvoering, zoals:
                <li class="list">afboeking van de herinvesteringsreserve op gekochte activa</li>
                <li class="list">boekverlies op activa</li>
                <li class="list">opheffing van de negatieve terugkeerreserve</li>

            </div>
        </div>
    </div>

</div>

